<template>
  <div class="full-width">
    <PrimaryButton @click.native="openDialog" light full-width>
      Add Contract
      <v-icon>mdi-plus</v-icon>
    </PrimaryButton>
    <ContractDialog v-if="isOpen" @close="isOpen = false" />
  </div>
</template>

<script>
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import ContractDialog from "@/views/offers/components/contracts/dialogs/ContractDialog";

export default {
  components: {
    PrimaryButton,
    ContractDialog
  },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    closeDialog() {
      this.isOpen = false;
    },
    openDialog() {
      this.isOpen = true;
    }
  }
};
</script>
